import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  ContributoUnificatoFormComponent
} from 'src/app/common/form/sez-economica/contributo-unificato-form.component';
import { ContributoUnificato } from 'src/app/common/models/contributo-unificato';
import { PropertiesSettings } from '../../../../core/configuration/properties-settings';
import { SezioneEconomicaResponse } from '../../../models/dto/sezione-economica-response';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { PetitumRevisione } from '../../../models/petitum-revisione';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';

@Component({
  selector: 'div [contributo-unificato-form-add]',
  templateUrl: '../../../form/sez-economica/contributo-unificato-form.component.html',
})

export class ContributoUnificatoAddComponent extends ContributoUnificatoFormComponent implements OnInit {
  petitumRevisione: PetitumRevisione;
  contributoUnificato: ContributoUnificato;
  urlInsert: string;
  sezione: SezioneEconomica;
  fascicolo: FascicoloFull;
  @Input() edit: boolean = false;
  @Output() onReturn: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>();

  ngOnInit() {
    this.setTitle('Aggiungi Contributo unificato');
    this.isInserimento(true);
  }

  getEdit() {
    return this.edit;
  }

  getContributoUnificato() {
    return new ContributoUnificato();
  }

  getRequest(contributoUnificatoRequest: ContributoUnificato) {
    let idSezione: string = PropertiesSettings.NEW_SEZIONE;
    if (this.sezione && this.sezione.id) {
      idSezione = this.sezione.id;
    }
    // debugger;
    this.operationService.addContributoUnificato(this.urlInsert, contributoUnificatoRequest, idSezione, this.fascicolo.id).
      subscribe((response: any) => this.datiResponse(response));
  }

  datiResponse(response: SezioneEconomicaResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(sezione: SezioneEconomica, fascicolo: FascicoloFull, urlInsert: string, recuperoCrediti: boolean) {
    this.fascicolo = fascicolo;
    this.sezione = sezione;
    this.urlInsert = urlInsert;
    //this.contributoUnificato = sezione.petitum.contributoUnificato;
    //this.petitumRevisione = petitumRevisione;
    this.recuperoCrediti = recuperoCrediti;
    this.createForm();
    this.populateSelect();
  }

}
